import "core-js/modules/es.array.concat.js";
import React from 'react';
import { getResourcePath } from '@finect/front-core/Routes';
import { withTheme } from 'styled-components';
import { Section } from '../../Section';
import { QuestionsBlock } from '../../Questions';
export var FundQuestionsSummary = function FundQuestionsSummary(_ref) {
  var theme = _ref.theme,
    fund = _ref.fund,
    user = _ref.user,
    bottomMargin = _ref.bottomMargin,
    product = _ref.product,
    questions = _ref.questions,
    finectApp = _ref.finectApp;
  var path = getResourcePath(theme, 'WriteQuestion');
  var headerLink = product && product.hasOwnProperty('entity') && product.entity.socialStats.questions.total ? {
    href: "".concat(path.url, "?product=").concat(product.entity.id),
    text: "Escribe tu pregunta",
    rel: 'nofollow'
  } : null;
  return React.createElement(Section, {
    id: "preguntas",
    bottomMargin: bottomMargin || false,
    title: "Preguntas relacionadas",
    headerLink: headerLink
  }, React.createElement(QuestionsBlock, {
    questions: questions,
    finectApp: finectApp,
    asideHidden: false,
    product: fund,
    me: user,
    showMoreButton: true,
    qty: 2
  }));
};
export default React.memo(withTheme(FundQuestionsSummary));